import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// ...existing code...
import GenericCallback from './dashboards/GenericCallback';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import InputDashboard from './dashboards/inputDashboard';
// ...existing code...
import OutputDashboard from './dashboards/outputDashboard';
import Login from './auth/Login';
import SignUp from './auth/SignUp';

const navStyle: React.CSSProperties = {
  padding: 16,
  background: 'linear-gradient(90deg,#3182ce 0%,#6b46c1 100%)',
  marginBottom: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
};

const linkStyle: React.CSSProperties = {
  color: '#fff',
  fontWeight: 600,
  fontSize: 18,
  marginRight: 24,
  textDecoration: 'none',
  padding: '8px 16px',
  borderRadius: 4,
  transition: 'background 0.2s',
};



const AppRoutes: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check for token in localStorage on every route change
    const token = localStorage.getItem('jwtToken');
    setIsAuthenticated(!!token);
  }, [location]);

  useEffect(() => {
    // Listen for storage changes (e.g., in another tab)
    const handleStorage = () => {
      const token = localStorage.getItem('jwtToken');
      setIsAuthenticated(!!token);
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('profile');
    setIsAuthenticated(false);
    window.location.href = '/auth/login';
  };

  return (
    <>
      <nav style={navStyle}>
        <div>
          {isAuthenticated && <Link to="/" style={linkStyle}>Input Dashboard</Link>}
          {isAuthenticated && <Link to="/output" style={linkStyle}>Output Dashboard</Link>}
          {isAuthenticated && <a href="#profile-section" style={{ ...linkStyle, background: '#38a169' }}>Profile</a>}
        </div>
        <div>
          {!isAuthenticated && <Link to="/auth/login" style={{ ...linkStyle, background: '#3182ce' }}>Login</Link>}
          {!isAuthenticated && <Link to="/auth/signup" style={{ ...linkStyle, background: '#6b46c1' }}>Sign Up</Link>}
          {isAuthenticated && (
            <button
              onClick={handleLogout}
              style={{ ...linkStyle, background: '#e53e3e', border: 'none', cursor: 'pointer' }}
            >
              Logout
            </button>
          )}
        </div>
      </nav>
      <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/signup" element={<SignUp />} />
        <Route path="/callback/:provider" element={<GenericCallback provider={':provider'} />} />
        {/* Protected routes: only show dashboards if authenticated */}
        {isAuthenticated && <Route path="/" element={<InputDashboard />} />}
        {isAuthenticated && <Route path="/output" element={<OutputDashboard />} />}
        {/* Redirect unauthenticated users to login for all other routes */}
        {!isAuthenticated && <Route path="*" element={<Login />} />}
      </Routes>
    </>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
    <AppRoutes />
  </BrowserRouter>
);

export default App;
